import { useRef, useEffect, useState } from "react";
import Link from "next/link";
import Image from "next/legacy/image";
import dayjs from "dayjs";
import { fitIn } from "@/utils/imageHandler";
import ContentWishlistComponent from "@/components/parts/ContentWishlistComponent";

const NewsCard = ({ data, cardHeight }) => {
  return (
    <div className='relative'>
      <div className='absolute z-20 top-1 right-1'>
        <ContentWishlistComponent
          item={data}
          content_type_name_prop={data.content_type.name}
          isDarkBackground={false}
        />
      </div>
      <Link
        href={`/news/${data.slug}`}
        className={`block relative aspect-[188/250] rounded-md overflow-hidden ${
          cardHeight ?? "h-full"
        }`}
      >
        <Image
          src={fitIn(data.thumbnail_url, 600)}
          objectFit='cover'
          layout='fill'
          alt='Image'
          className='transition-all duration-300'
        />
        <span className='absolute inset-0 bg-gradient-to-b from-[#23212E]/0 to-[#23212E]'></span>
        <div className='absolute bottom-0 left-0 w-full p-2.5 text-white lg:p-3.5'>
          <span className='inline-block text-[11px] lg:text-xs font-semibold text-transparent bg-clip-text bg-gradient-to-r from-yellow-1 to-red-1 mb-0'>
            {data.content_type.name}
          </span>
          <p className='text-[10px] lg:text-xs text-white/70 mb-1.5'>
            {dayjs(data.publish_date).format('DD MMMM YYYY')}
          </p>
          <p
            className={`text-xs lg:text-sm leading-tight font-semibold lg:leading-tight line-clamp-4`}
          >
            {data.title}
          </p>
        </div>
      </Link>
    </div>
  );
};

export default NewsCard;
